/**
 * Created by jonas on 2021-10-22.
 */
import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {gsap} from "gsap";
import {isTrueGritStackedWildSymbol, TrueGritStackedWildSymbol} from "../../reels/TrueGritStackedWildSymbol";
import {TrueGrit} from "../../TrueGrit";
import {ISymbol} from "../../../core/reel/ReelInterfaces";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";

export class TruGritXNudgePresentation implements SimplePresentation {
    private stackedWildPositions:number[];

    constructor() {}

    shouldRun():boolean {
        //If has xNudge.
        this.stackedWildPositions = []
        for (let i:number = 0; i < TrueGrit.model.botTrain.symbols.length; i++) {
            if (TrueGrit.model.botTrain.symbols[i] == "W2" && TrueGrit.model.botTrain.isRevealed[i]) {
                this.stackedWildPositions.push(i + 1);//Bottom reel positions start a 1
            }
        }
        return this.stackedWildPositions.length > 0;
    }

    start(controller:SimplePresentationRunnerController):void {
        const tl:gsap.core.Timeline = gsap.timeline();

        const symbols:ISymbol[] = TrueGrit.bottomReelView.getSymbolsBySymbolPositions(this.stackedWildPositions);
        const stackedWilds:TrueGritStackedWildSymbol[] = [];
        for (let sym of symbols) {
            if (isTrueGritStackedWildSymbol(sym)) {
                stackedWilds.push(sym);
            }
        }

        for (let wild of stackedWilds) {
            const symbolsOnReel:ISymbol[] = TrueGrit.allReelsView.mainReelModels[wild.reelPosition + 1].getAllSymbols();
            symbolsOnReel.reverse();
            const steps:{size:number, multiplier:number}[] = [];

            for (let reelSymbol of symbolsOnReel) {
                const symPartCount:number = reelSymbol.splitLevel == 0 ? 1 : reelSymbol.splitLevel;
                const isWild = reelSymbol.symbolName == "W" || reelSymbol.transformed;


                for (let i:number = 0; i < symPartCount; i++) {
                    steps.push({
                        size:1 / symPartCount,
                        multiplier:(isWild && i == 0)? 2 : 1,
                    })
                }
            }

            const isInWin = TrueGrit.model.allWinPositions[wild.reelPosition + 1][1] && TrueGrit.model.allWinPositions[wild.reelPosition + 1][2]; //Quick and dirty check if nudge wild is in win.
            const fastNudge = TrueGrit.apiPlugin.settings.get(APISetting.FAST_SPIN, false) || !isInWin;

            tl.add(wild.nudge(steps, isInWin,  fastNudge));
        }
        tl.add(() => controller.finish(), "+=0.001");
    }

}